import clsx from "clsx";
import React from "react";

interface CustomHTMLProps extends React.HTMLProps<HTMLInputElement> {
  icon: React.ReactNode;
  containerClassName?: string;
  handelBack?: () => void;
}

type MergedProps = React.HTMLProps<HTMLInputElement> & CustomHTMLProps;

const InputWithEndIcon: React.FC<MergedProps> = ({ icon, containerClassName, handelBack, ...props }) => {
  return (
    <div className={clsx(containerClassName)}>
      <div className="relative  rounded-md shadow-sm">
        <input
          {...props}
          className="block w-full   rounded-md border-0  py-[5px] pr-10 text-gray-900  placeholder:text-gray-400 border-gray-500 ring-1 text-xs md:text-sm sm:leading-6"
        />
        <div
          className="pointer-events-auto absolute inset-y-0 right-0 flex items-center pr-3 cursor-pointer"
          onClick={handelBack} // Use the handelBack function
        >
          {icon}
        </div>
      </div>
    </div>
  );
};

export default InputWithEndIcon;
